module.exports = __webpack_public_path__ + "static/img/logo_large.80a64f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_large.png
// module id = LmxD
// module chunks = 1